import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Megaphone } from "lucide-react";

const AZIONI = ["Ribasso prezzo", "Open house", "Nuove foto o annuncio", "Incontro con il venditore", "Rinnovo o chiusura incarico"];

function Risposta({ s, onDone }) {
  const [azione, setAzione] = useState("");
  const [nota, setNota] = useState("");
  const invia = async () => {
    try { await api.post(`/solleciti-fermo/${s.id}/rispondi`, { azione, nota }); toast.success("Piano d'azione inviato al Socio"); onDone(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="mt-2 space-y-2" data-testid={`sollecito-risposta-form-${s.id}`}>
      <select data-testid="sollecito-azione" value={azione} onChange={(e) => setAzione(e.target.value)} className="w-full px-3 py-2 rounded-xl border border-[var(--border)] bg-white text-base sm:text-sm">
        <option value="">— Scegli l'azione —</option>{AZIONI.map((a) => <option key={a}>{a}</option>)}
      </select>
      <textarea data-testid="sollecito-nota" value={nota} onChange={(e) => setNota(e.target.value)} rows={2} placeholder="Piano d'azione (obbligatorio)" className="w-full px-3 py-2 rounded-xl border border-[var(--border)] text-base sm:text-sm" />
      <button data-testid="sollecito-invia-risposta" disabled={!azione || nota.trim().length < 5} onClick={invia} className="px-4 py-2 rounded-xl bg-[#111111] text-white text-sm font-semibold disabled:opacity-40">Invia risposta e chiudi il task</button>
    </div>
  );
}

export default function SollecitiFermo({ immobileId }) {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const load = () => api.get(`/immobili/${immobileId}/solleciti-fermo`).then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, [immobileId]); // eslint-disable-line
  if (!list.length) return null;
  return (
    <div className="card-immo p-4 mb-4 border-red-200" data-testid="solleciti-fermo-box">
      <div className="flex items-center gap-2 font-bold text-sm mb-2"><Megaphone size={16} className="text-red-600" /> Sollecito immobile fermo</div>
      {list.map((s) => (
        <div key={s.id} className={`py-2 border-t border-[var(--border)] text-sm ${s.stato === "scaduto" ? "text-red-700" : ""}`} data-testid={`sollecito-${s.id}`}>
          <div><b>{new Date(s.at).toLocaleString("it-IT")}</b> · sollecitato da {s.by} a {(s.direttori || []).join(", ")}{s.nota ? ` · “${s.nota}”` : ""}</div>
          {s.risposta ? <div className="text-emerald-700">Risposta di {s.risposta.by} ({new Date(s.risposta.at).toLocaleString("it-IT")}): <b>{s.risposta.azione}</b> — {s.risposta.nota}</div>
            : <div className="font-semibold">{s.stato === "scaduto" ? "Scaduto senza risposta" : `In attesa di risposta entro ${new Date(s.scadenza_at).toLocaleString("it-IT")}`}</div>}
          {!s.risposta && (s.direttori_ids || []).includes(user?.id) && <Risposta s={s} onDone={load} />}
        </div>
      ))}
    </div>
  );
}
